import { defineMessages } from 'react-intl';

export default defineMessages({
  videoUpload: {
    id: 'app.App.Video.VimeoUploader.VideoPreviewContainer.videoUpload',
    defaultMessage: 'Envio do vídeo',
  },
  uploadPreview: {
    id: 'app.App.Video.VimeoUploader.VideoPreviewContainer.uploadPreview',
    defaultMessage: 'Preview do upload',
  },
  discardVideo: {
    id: 'app.App.Video.VimeoUploader.VideoPreviewContainer.discardVideo',
    defaultMessage: 'Excluir vídeo',
  },
  downloadVideo: {
    id: 'app.App.Video.VimeoUploader.VideoPreviewContainer.downloadVideo',
    defaultMessage: 'Baixar vídeo',
  },
  editThumbnail: {
    id: 'app.App.Video.VimeoUploader.VideoPreviewContainer.editThumbnail',
    defaultMessage: 'Editar thumbnail',
  },
  errorDownloadingVideo: {
    id: 'app.containers.Video.VimeoUploader.VideoPreviewContainer.errorDownloadingVideo',
    defaultMessage: 'Erro ao baixar vídeo. Tente novamente mais tarde.',
  },
  errorDeletingVideo: {
    id: 'app.containers.Video.VimeoUploader.VideoPreviewContainer.errorDeletingVideo',
    defaultMessage: 'Erro ao deletar vídeo. Tente novamente mais tarde.',
  },
});
